import { StringUtil } from '@nomidio/common';

export enum IdentifierStatus {
  Pending = 'PENDING',
  Verified = 'VERIFIED',
  Suspended = 'SUSPENDED',
}

export function IdentifierStatusPresentation(status: IdentifierStatus): string {
  switch (status) {
    case IdentifierStatus.Pending:
    case IdentifierStatus.Verified:
    case IdentifierStatus.Suspended:
      return StringUtil.toPresentationFormat(status);
    default:
      console.warn(`Unrecognised Identifier status '${status}' requested for presentation`);
      return StringUtil.toPresentationFormat(status);
  }
}
